interface VersionedObject {
  id: ID!
  created_at: String
  version: Int
  version_created_at: String
}

interface BankAccount {
  sort_code: String
  number: String
}

interface LedgerBase {
  id: Int!
  advisorId: String
  advisor: User
  caseId: String
  clientIds: [String!]
  clients: [ClientVersion!]
  clubId: String
  club: Organisation
  propertyId: String
  sourceId: LedgerPaymentSourceId
  property: PropertyVersion
  type: LedgerType
  isOverdue: Boolean
}
